import ButtonGroup from '@visa/vds/button-group';
import ButtonText from '@visa/vds/button-text';
import Col from '@visa/vds/col';
import Grid from '@visa/vds/grid';
import Icon from '@visa/vds/icon';
import Row from '@visa/vds/row';
import Typography from '@visa/vds/typography';
import { AuthenticatedExternalUserRoutes } from '_constants/PageRoutes';
import MCSSpace from 'components/MCSSpace';
import React from 'react';
import { useHistory } from 'react-router-dom';

const OrderConfirmation = (props) => {
    let { orderConfirmation } = props;
    const history = useHistory();

    const redirectTo3DSMain = () => {
        window.location.reload();
    }

    const redirectToFilteredSubscriptionPage = (orderRef) => {
        history.push({
            pathname: AuthenticatedExternalUserRoutes.SUBSCRIPTIONS,
            search: '?orderRef=' + orderRef
        })
    }

    return (
        <>
            <MCSSpace height="30px" />
            <Grid>
                <Row>
                    <Col textAlign="center">
                        <Typography tag="h3" id="order-success-text">Order placed successfully!</Typography>
                    </Col>
                </Row>
                <Row>
                    <Col textAlign="center">
                        <Icon name="success" resolution="high" />
                    </Col>

                </Row>
                {orderConfirmation &&
                    <Row>
                        <Col textAlign="center">
                            <Typography tag="h3">Order Reference :&nbsp;
                                <a id="order-reference-link" className="vds-link" onClick={() => redirectToFilteredSubscriptionPage(orderConfirmation.orderId)}>
                                    {orderConfirmation.orderId}
                                </a>
                            </Typography>
                        </Col>
                    </Row>
                }
            </Grid>
            <ButtonGroup direction="right">
                <ButtonText onClick={redirectTo3DSMain}>Done</ButtonText>
            </ButtonGroup>
        </>);
}

export default OrderConfirmation